import React from 'react'
import { icon } from '../../../services/icon'

const Link = ({ url, targetBlank = false, children, isIcon = true, className }) => {
    return (
        <a
            className={`baseocom-text-black baseocom-underline !baseocom-mb-0 ${className} !baseocom-shadow-none baseocom-w-full baseocom-overflow_wrap link`}
            href={url}
            target={targetBlank ? '_blank' : null}
            rel={targetBlank ? 'noopener noreferrer' : null}
        >
            <span>{children}</span>

            {targetBlank && isIcon && (
                <span className="baseocom-ml-1">{icon('external-link')}</span>
            )}
        </a>
    )
}

export default Link
